import { ChakraProvider } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Navigate, Route, Routes } from "react-router-dom";
import "./assets/css/App.css";
import AdminLayout from "./layouts/admin";
import AuthLayout from "./layouts/auth";
import RTLLayout from "./layouts/rtl";
import initialTheme from "./theme/theme"; //  { themeGreen }
import i18next from "i18next";
import { APP_LANGUAGE } from ".././src/utils/Api";
// Chakra imports

function App() {
  const [currentTheme, setCurrentTheme] = useState(initialTheme);

  useEffect(() => {
    localStorage.setItem("i18nextLng", APP_LANGUAGE || "en");
    i18next.changeLanguage(APP_LANGUAGE || "en");
  }, []);

  return (
    <>
      <ChakraProvider theme={currentTheme}>
        <Routes>
          <Route path="auth/*" element={<AuthLayout />} />
          <Route
            path="admin/*"
            element={
              <AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />
            }
          />
          <Route
            path="rtl/*"
            element={
              <RTLLayout theme={currentTheme} setTheme={setCurrentTheme} />
            }
          />
          <Route path="/" element={<Navigate to="/admin" replace />} />
        </Routes>
      </ChakraProvider>
    </>
  );
}

export default App;
